<div class="sk-top-events">
    <div class="sk-top-sports sk-h-12 sk-b-rad8"></div>
    @for (top of [0, 1, 2]; track top) {
        <div class="sk-top-team sk-h-12 sk-b-rad8">
            <div class="sk-circle"></div>
            <div class="sk-top-players">
                <div class="sk-top-player1 sk-h-12 sk-b-rad8"></div>
                <div class="sk-top-player2 sk-h-12 sk-b-rad8"></div>
            </div>
        </div>
    }
</div>
